import React, { useEffect, useState } from "react";
import useCategory from "../../../../Hooks/Support/useCategory";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "../../../../Components/Modal";
import { ContainerFlex, Row, Column } from "../../../../Components/Layout";
import { Input, FormLabel } from "../../../../Components/Form";
import { Button, ButtonModalClose } from "../../../../Components/Button";
import { Switch } from "../../../../Components/Form";
import { Text } from "../../../../Components/Text";

const CategoryModal = ({ setReload }) => {
  const [id, setId] = useState("");
  const { dataCategory, postCategory, updateCategory } = useCategory();

  const [category, setCategory] = useState("");
  const [validCategory, setValidCategory] = useState("");

  const [active, setActive] = useState(true);

  const [error, setError] = useState({});
  const handleError = (err) => {
    setError(err);
  };

  const handleId = (e) => {
    setId(e.target.value);
  };

  const handleCategory = (e) => {
    setCategory(e.target.value);
    setValidCategory("");
  };

  const handleActive = () => {
    setActive(!active);
  };

  const handleSuccess = () => {
    document.getElementById("Modal_Category_Close").click();
    setReload();
    handleDataDefault(null);
  };

  const handleValidade = () => {
    let err = true;
    if (category.length <= 3 || category.length >= 100) {
      setValidCategory("O nome da categoria é inválido.");
      err = false;
    }

    return err;
  };

  const handleConfirm = () => {
    if (handleValidade()) {
      if (id === "") {
        let params = {
          name: category,
          is_active: active,
        };
        postCategory(params, handleSuccess, handleError);
      } else {
        let params = {
          name: category,
          is_active: active,
        };
        updateCategory(id, params, handleSuccess, handleError);
      }
    }
  };

  const handleDataDefault = (Data) => {
    if (Data && Data.id) {
      setId(Data.id);
      setCategory(Data.name);
      setActive(Data.delete_at ? false : true);
    } else {
      setTimeout(() => {
        setId("");
        setCategory("");
        setActive(true);
        setValidCategory("");
      }, 1000);
    }
  };

  useEffect(() => {
    handleDataDefault(dataCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCategory]);

  return (
    <Modal id="Support_Category_Modal" center fixed scroll>
      <ModalHeader
        title="Cadastro de Categoria"
        id="Modal_Category_Close"
        onClick={handleDataDefault}
        border={false}
      />
      <ModalBody>
        <Row>
          {error && error.status && error.data.message && (
            <Column col="12" marginBottom="3">
              <div className="alert alert-danger m-3">
                <Text tag="h6" fontWeight="bolder">
                  Erro: {error.status} - {error.data.message}
                </Text>
                <Text fontWeight="bolder"></Text>
                <p>{error.data.errors && JSON.stringify(error.data.errors)}</p>
              </div>
            </Column>
          )}
          <Input value={id} onChange={handleId} maxLength={60} type="hidden" />
          <Column col="12" marginBottom="3">
            <FormLabel>Nome da Categoria</FormLabel>
            <Input
              value={category}
              onChange={handleCategory}
              maxLength={60}
              required
              className={validCategory && "is-invalid"}
              onKeyDown={() => setValidCategory("")}
            />
            {validCategory && (
              <div className="invalid-feedback">{validCategory}</div>
            )}
          </Column>

          <Column col="12" md="5" marginBottom="3">
            <FormLabel>Status</FormLabel>
            <Switch
              id="is_active"
              label={active ? "Ativo" : "Inativo"}
              onClick={handleActive}
              checked={active}
            />
          </Column>
        </Row>
      </ModalBody>
      <ModalFooter border={false}>
        <ContainerFlex between width>
          <ButtonModalClose
            bgColor="danger"
            txtColor="white"
            onClick={handleDataDefault}
          >
            Cancelar
          </ButtonModalClose>
          <Button bgColor="success" txtColor="white" onClick={handleConfirm}>
            Concluir
          </Button>
        </ContainerFlex>
      </ModalFooter>
    </Modal>
  );
};

export default CategoryModal;
